import idb from "@/plugins/indexdb.js";
import LiftRepo from "@/repositories/products/lift";

import liftDefaultForm from "./forms/lift";

export default {
  namespaced: true,

  state: {
    lift: liftDefaultForm
  },

  mutations: {
    SET_LIFT(state, payload) {
      state.lift = Object.assign({}, state.lift, payload); // Merge
    },

    RESET_LIFT(state) {
      state.lift = liftDefaultForm;
    }
  },

  actions: {
    /**
     * Get lift product by uuid
     *
     * @param {String} lift_uuid Lift uuid
     */
    async get({ commit }, lift_uuid) {
      try {
        const { data } = await LiftRepo.get(lift_uuid);
        commit("SET_LIFT", data);
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Create a new lift
    async createLift(context, payload) {
      try {
        const { data } = await LiftRepo.createLift(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },

    /**
     * Get lift product from IndexedDB
     *
     * @param {String} lift_uuid Lift uuid
     */
    async getFromLocal({ commit }, lift_uuid) {
      const lift = await idb.db.lift.get(lift_uuid);

      // If not found return null
      if (!lift) return null;

      commit("SET_LIFT", lift);

      return lift;
    },

    // Reset lift
    resetProduct({ commit }) {
      commit("RESET_LIFT");
    }
  }
};
